function Coupon({ code, discount, isActive }) {
  this.code = code;
  this.discount = discount;
  this.isActive = isActive;
}

export default Coupon;
